import React from 'react';
import { Link, useNavigate } from "react-router-dom";
import Logo from '../../assets/images/logo.png';
import closeicon from '../../assets/images/close.svg';

const AuthHeader = () => {
  const navigate = useNavigate();

  const handleNavigate = () => {
    navigate(-1);
  }
  return (
    <div>
      <div className='container-fluid'>
        <div className='row authheader'>
          <div className='col-lg-12 d-flex justify-content-between'>
            <div>
              <Link
                to="/"
              ><img src={Logo} alt="logo" className='logo' /></Link>
            </div>
            <div onClick={handleNavigate} className='cursor-pointer'>
              <img alt='' src={closeicon} className='close-icon' />
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default AuthHeader